import { Component, OnInit } from '@angular/core';
import { LOOKUP } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lookups-sort-order',
  templateUrl: './lookups-sort-order.component.html',
  styleUrls: ['./lookups-sort-order.component.scss']
})
export class LookupsSortOrderComponent implements OnInit {
  content: any;
  heading: string;
  lookupList: LOOKUP[];
  action: Subject<any> = new Subject();

  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.getLookups();
  }

  getLookups() {
    this.summaryService.getLookupsSummary(this.content.id).subscribe(summary => {
      this.lookupList = summary;
    });
  }

  listSorted(event:any){
    //console.log(event);
  }

  Save(): void {
    for (let i = 0; i < this.lookupList.length; i++) {
      if (this.lookupList[i].RECORD_STATE)
        this.lookupList[i].RECORD_STATE = 1;
      else
        this.lookupList[i].RECORD_STATE = 0;
    }
    this.summaryService.updateLookups(this.lookupList).subscribe(summary => {
      this.commonService.SuccessBanner("Data has been updated successfully");
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been updated successfully' } } });
      
      this.modalRef.close();
    });
  }

}
